function transformAddress(addressData: any): any {
  return {
    streetNumber: addressData.buildingNumber,
    streetName: addressData.street,
    city: addressData.city,
    state: addressData.state,
    country: addressData.country,
    postalCode: addressData.zipCode,
    position: {
      lat: addressData.lat,
      lng: addressData.long,
    },
    fullAddress: [
      addressData.country,
      addressData.state,
      addressData.city,
      addressData.street,
      addressData.buildingNumber,
    ]
      .filter(Boolean)
      .join(", "),
    address: [addressData.city, addressData.street, addressData.buildingNumber]
      .filter(Boolean)
      .join(", "),
  };
}
export default transformAddress;
